/**
 * Shared reCAPTCHA v3 helper — used by any form that needs a token
 * (contact, newsletter, blog comments, ...).
 */
export const getRecaptchaToken = async (action: string): Promise<string> => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
  if (!siteKey) return '';
  try {
    const grecaptcha = (window as any).grecaptcha;
    if (!grecaptcha) return '';
    return await grecaptcha.execute(siteKey, { action });
  } catch {
    return '';
  }
};
